import { Form } from '@form/Form';
import FormInput from '@form/FormInput';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useApi } from '../../hooks/useApi';

export const Register = ({ loginCallback, affiliate }) => {
    const [finished, setFinished] = useState(false);

    return finished ? (
        <Confirmation />
    ) : (
        <RegisterForm loginCallback={loginCallback} affiliate={affiliate} callback={() => setFinished(true)} />
    );
};

export const RegisterForm = ({ loginCallback, affiliate: _affiliate, callback = () => {} }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [affiliate, setAffiliate] = useState(_affiliate);
    const api = useApi();
    const { t } = useTranslation('auth');

    useEffect(() => {
        setAffiliate(_affiliate || localStorage.getItem('AffiliateRegistrationKey'));
    }, [_affiliate]);

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: 'register',
            method: 'POST',
            data: { ...data, affiliate },
            onSuccess: callback,
            onFinish: () => setIsLoading(false)
        });
    };

    return (
        (<Form onSubmit={handleSubmit}>
            <FormInput type="text" name="name" label={t('Name') + ' *'} autoFocus />
            <FormInput type="email" name="email" label={t('E-Mail Adresse') + ' *'} />
            <FormInput type="password" name="password" label={t('Passwort') + ' *'} />
            <FormInput type="password" name="password_confirmation" label={t('Passwort wiederholen') + ' *'} />
            <span className="tw-flex tw-items-start tw-justify-between">
                <FormInput.Checkbox name="agb_check" label={t('Ich akzeptiere die AGB') + ' *'} />
                <Link href="/agb" className="tw-text-success hover:tw-text-success/80">

                    <Trans ns="auth">zu den AGBs</Trans>

                </Link>
            </span>
            <span className="tw-flex tw-items-start tw-justify-between">
                <FormInput.Checkbox name="pp_check" label={t('Ich akzeptiere die Datenschutzbestimmungen') + ' *'} />
                <Link href="/datenschutz" className="tw-text-success hover:tw-text-success/80">

                    <Trans ns="auth">zu den Datenschutzbestimmungen</Trans>

                </Link>
            </span>
            <p className="mt-2 tw-text-center tw-text-accents-7">
                <Trans ns="auth">
                    Wir werden wichtige Updates zu deinem Training (Buchungsbestätigungen, Auftragsbestätigungen, ...)
                    per E-Mail schicken.
                </Trans>
            </p>
            <FormInput.Submit isLoading={isLoading}>
                <Trans ns="auth">Registrieren</Trans>
            </FormInput.Submit>
            {loginCallback && (
                <>
                    <hr className="my-3" />
                    <p className="text-center text-muted">
                        <Trans ns="auth">Du bist bereits Nutzer?</Trans>{' '}
                        <button
                            className="btn btn-link"
                            onClick={(e) => {
                                e.preventDefault();
                                loginCallback();
                            }}
                        >
                            <Trans ns="auth">Einloggen</Trans>
                        </button>
                    </p>
                </>
            )}
        </Form>)
    );
};

export const Confirmation = () => {
    return (
        <div className="text-center">
            <div className="tw-relative tw-mb-6 tw-aspect-square tw-w-full">
                <Image layout="fill" src="/images/completed.svg" alt="register_completed_img" />
            </div>
            <h1>
                <Trans ns="auth">Herzlichen Glückwunsch!</Trans>
            </h1>
            <p>
                <Trans ns="auth">
                    Eine E-Mail mit einem Bestätigungslink wurde an die angegebene Adresse verschickt. Bitte klicke auf
                    den in der E-Mail enthaltenen Link und schließe somit den Registrierungsprozess ab.
                </Trans>
            </p>
            <p className="tw-text-accents-7">
                <Trans ns="auth">
                    Solltest du keine E-Mail von uns erhalten haben, überprüfe bitte deinen Spamordner oder lass dir
                    über dein Dashboard nach dem Login eine neue E-Mail zusenden.
                </Trans>
            </p>
        </div>
    );
};
